import React, { memo, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { getProductManagementTable } from "../../Utils/ProductManagement/ProductManagementUtils";
import { getProductManagementDataAPI } from "../../API/productmanagement";

function ProductManagementTable() {
  const [productManagementTableData, setProductManagementTable] = useState();

  useEffect(async () => {
    let productManagementTableDataAPI = await getProductManagementDataAPI();
    console.log(productManagementTableDataAPI)
    setProductManagementTable(
      getProductManagementTable(productManagementTableDataAPI.data)
    );
  }, []);

  return (
    <>
      <div className="handwai-dark organisationBorerStyle">
        <Container fluid>
          <Row>
            <Col>
              <table id="organisationManagementTable" className="table">
                <thead>
                  <tr>
                    <th data-sortable="true" data-searchable="true">
                      Organisation
                    </th>
                    <th data-sortable="true" data-searchable="true">
                      Upload LVs
                    </th>
                    <th data-sortable="true" data-searchable="true">
                      Done LVs
                    </th>
                  </tr>
                </thead>
                <tbody>{productManagementTableData}</tbody>
              </table>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default memo(ProductManagementTable);
